import nanoid from 'nanoid'
import { action } from 'overmind'

import * as itemType from '../constant'
// import { action } from 'overmind'

export const getValuesFromServer = async ({ state, effects }) => {
  const dataFromServer = await effects.form.getForm()
  // state.form.data = dataFromServer
  dataFromServer.map(item => {
    if (item.fields.sessid?.structure?.valueDefault) {
      state.form.sessid = item.fields.sessid?.structure?.valueDefault
    }
  })
}

export const setVisable = ({ state }) => {
  state.form.isLoad = !state.form.isLoad
}

export const updateFormState = ({ state }, { form, values }) => {
  state.form.values[form] = values
}

export const updateFormType = ({ state }, { type }) => {
  state.form.type = type
}

export const updateFormId = ({ state }, id) => {
  state.form.formid = id
}

export const sendForm = async ({ state, effects }, values) => {
  const res = await effects.form.addForm(values)
  state.form.send = res
  state.form.sending = true
}

export const checkLastItem = ({ state }) => {
  const getFormType = state.form.data.findIndex(item => item.id === state.form.type)
  const getFieldByStep =
    state.form.data[getFormType].fields[Object.keys(state.form.data[getFormType].fields)[state.form.step]]

  return false
}

export const pushTypeForm = ({ state }) => {
  state.form.queue[0].push({
    type: itemType.BUTTON_RADIO_TYPE,
    content: {
      items: state.form.data.map(item => {
        return {
          name: item.name,
          id: item.id,
          sid: item.sid,
          submitButton: item.submitButton
        }
      })
    }
  })
}

export const setFormType = ({ state }, { formIdx, typeIdx }) => {
  state.form.formIdx = formIdx
  state.form.typeIdx = typeIdx
}

export const resetForm = ({ state }) => {
  state.form.step = 0
  state.form.type = undefined
  state.form.formid = undefined
  state.form.queue = [[]]
  state.form.values = [{ values: { type: '0' } }]
  state.form.formIdx = null
}

export const pushSubmitToForm = ({ state }) => {
  state.form.queue[state.form.formIdx].push({
    type: itemType.HIDDEN_TYPE,
    content: {
      id: nanoid(),
      name: 'WEB_FORM_ID',
      value: () => {
        if (state.form.formid) {
          return state.form.formid === 4 ? 3 : state.form.formid
        }
        return state.form.data[state.form.typeIdx].id
      }
    }
  })

  state.form.queue[state.form.formIdx].push({
    type: itemType.HIDDEN_TYPE,
    content: {
      id: nanoid(),
      name: 'sessid',
      value: state.form.sessid
    }
  })

  state.form.queue[state.form.formIdx].push({
    type: itemType.HIDDEN_TYPE,
    content: {
      id: nanoid(),
      name: 'web_form_submit',
      value: 'Y'
    }
  })

  state.form.queue[state.form.formIdx].push({
    type: itemType.SUBMIT_TYPE,
    content: {
      id: nanoid()
    }
  })
  return null
}

export const pushNextToForm = ({ state }) => {
  state.form.queue[state.form.formIdx].push({
    type: itemType.NEXT_TYPE,
    content: {
      id: nanoid()
    }
  })
  return null
}

export const pushUserIconToForm = ({ state }) => {
  state.form.queue[state.form.formIdx].push({
    type: itemType.USER_TYPE,
    content: {
      id: nanoid()
    }
  })
  return null
}

export const pushMessageToForm = ({ state }, text) => {
  state.form.queue[state.form.formIdx].push({
    type: itemType.MESSAGE_FROM_TYPE,
    content: {
      id: nanoid(),
      message: {
        id: nanoid(),
        text: text
      }
    }
  })
}
export const pushElementForm = ({ state, actions }, { fields }) => {
  if (fields.structure[0]?.type === 'text') {
    if (fields.structure[0]?.if && fields.structure[0].if === state.form.formid) {
      return null
    }
    state.form.queue[state.form.formIdx].push({
      type: itemType.INPUT_TEXT_TYPE,
      content: {
        id: nanoid(),
        name: fields.structure[0].name,
        message: {
          id: nanoid(),
          text: fields.caption
        }
      }
    })

    return null
  }

  if (fields.structure[0]?.type === 'phone') {
    state.form.queue[state.form.formIdx].push({
      type: itemType.INPUT_PHONE_TYPE,
      content: {
        id: nanoid(),
        name: fields.structure[0].name,
        message: {
          id: nanoid(),
          text: fields.caption
        }
      }
    })

    return null
  }

  if (fields.structure[0]?.type === 'email') {
    state.form.queue[state.form.formIdx].push({
      type: itemType.INPUT_EMAIL_TYPE,
      content: {
        id: nanoid(),
        name: fields.structure[0].name,
        message: {
          id: nanoid(),
          text: fields.caption
        }
      }
    })

    return null
  }

  if (fields.structure[0]?.type === 'textarea') {
    state.form.queue[state.form.formIdx].push({
      type: itemType.TEXTAREA_TYPE,
      content: {
        id: nanoid(),
        name: fields.structure[0].name,
        message: {
          id: nanoid(),
          text: fields.caption
        }
      }
    })

    return null
  }

  if (fields.structure[0]?.type === 'multiselect') {
    state.form.queue[state.form.formIdx].push({
      type: itemType.CHECKBOX_TYPE,
      content: {
        id: nanoid(),
        options: fields.structure,
        message: {
          id: nanoid(),
          text: fields.caption
        }
      }
    })
    return null
  }

  if (fields.structure[0]?.type === 'demo') {
    state.form.queue[state.form.formIdx].push({
      type: itemType.DEMO_TYPE,
      content: {
        id: nanoid(),
        options: fields.structure,
        message: {
          id: nanoid(),
          text: fields.caption
        }
      }
    })
    return null
  }

  return null
}

export const pushStepToForm = ({ state, actions }) => {
  const currentStep = state.form.step
  actions.form.pushMessageToForm(state.form.data[state.form.typeIdx].steps[state.form.step].title)
  actions.form.pushUserIconToForm()
  state.form.data[state.form.typeIdx].steps[state.form.step].fields.map(item => {
    actions.form.pushElementForm({ fields: item })
  })
  state.form.step = state.form.step + 1
  if (state.form.data[state.form.typeIdx].steps.length === state.form.step) {
    actions.form.pushSubmitToForm()
    return null
  }
  if (state.form.data[state.form.typeIdx].steps[currentStep].fields[0].structure[0]?.type !== 'demo') {
    actions.form.pushNextToForm()
  }
}
